import PropTypes from 'prop-types';
import React from 'react';
import { Linha } from '../../styles/base';
import { ListaHeader } from './HeaderListaEstilo';

const HeaderLista = ({ type }) => {
  if (type === 'sic-respondido') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Respondidos</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'sic-respondido2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Respondido</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'sic-pendente2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#EE796E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Pendente</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'sic-pendente') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#EE796E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Pendentes</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-avaliacoes') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Avalie este atendimento</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-aberta') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#EE796E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Abertas</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-agendada') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#479FEC', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Agendadas</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-emandamento') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#F1C50E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Em Andamento</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-pendente') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#F992F9', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Pendentes</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-concluida') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Concluídas</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-cancelada') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#999999', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Canceladas</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-avaliacoes2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Avalie este atendimento</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-aberta2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#EE796E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Aberto</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-agendada2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#479FEC', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Agendado</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-emandamento2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#F1C50E', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Em Andamento</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-pendente2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#F992F9', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Pendente</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-concluida2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#2DCC70', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Concluído</span>
        </ListaHeader>
      </Linha>
    );
  }

  if (type === 'ocorrencia-cancelada2') {
    return (
      <Linha>
        <ListaHeader style={{ backgroundColor: '#999999', borderColor: '#fff' }} className="controle-fundo">
          <span style={{ color: '#fff' }}>Cancelado</span>
        </ListaHeader>
      </Linha>
    );
  }

  return null;
};

HeaderLista.propTypes = {
  type: PropTypes.string,
};

HeaderLista.defaultProps = {
  type: null,
};

export default HeaderLista;
